import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const FlutterwaveAddCardContext = createContext(null);

type Props = {
  children: ReactElement;
};

const FlutterwaveAddCardProvider: FunctionComponent<Props> = ({ children }) => {
  const {
    mutateAsync: mutateAsyncAddCard,
    data: addCardData,
    isPending: addCardIsPending,
    error: addCardError,
  } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post("billings/flutterwave/addcard", payload);
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const {
    mutateAsync: mutateAsyncVerify,
    data: verifyData,
    isPending: verifyIsPending,
    error: verifyError,
  } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post(
        "billings/flutterwave/addcard/verify",
        payload,
      );
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsyncAddCard,
      addCardData,
      addCardIsPending,
      addCardError,

      mutateAsyncVerify,
      verifyData,
      verifyIsPending,
      verifyError,
    }),
    [
      mutateAsyncAddCard,
      addCardData,
      addCardError,
      addCardIsPending,
      mutateAsyncVerify,
      verifyData,
      verifyIsPending,
      verifyError,
    ],
  );
  return (
    <FlutterwaveAddCardContext.Provider value={contextValue}>
      {children}
    </FlutterwaveAddCardContext.Provider>
  );
};

export default FlutterwaveAddCardProvider;
